export default __webpack_public_path__ + "static/media/rentImage-1.8821fa3f.jpg";